import FixaHelperText from "@coworker/apprestructured/src/shared/wrappers/FixaHelperText/FixaHelperText";
import { ReactNode } from "react";

type ErrorAddOnProps = {
  children: ReactNode;
  testId?: string;
};

function ErrorAddOn({ children, testId }: ErrorAddOnProps) {
  return (
    <FixaHelperText data-testid={testId} shouldValidate={true}>
      {children}
    </FixaHelperText>
  );
}

export default ErrorAddOn;
